module.exports = __webpack_public_path__ + "static/media/huli_405.b40476ee.jpg";